import { TEXT_EVIDENCE_HEIGHT } from './types.js';
export const TEXT_COLUMN_MASK = (1 << TEXT_EVIDENCE_HEIGHT) - 1;
export function getColumnBit(columns, x, y) {
    if (x < 0 || y < 0 || x >= columns.length || y >= TEXT_EVIDENCE_HEIGHT)
        return false;
    return (((columns[x] ?? 0) >>> y) & 1) !== 0;
}
export function setColumnBit(columns, x, y) {
    columns[x] = (columns[x] ?? 0) | (1 << y);
}
const POPCOUNT = new Uint8Array(256);
for (let i = 1; i < POPCOUNT.length; i++)
    POPCOUNT[i] = POPCOUNT[i >>> 1] + (i & 1);
export function popcountByte(value) {
    return POPCOUNT[value & 0xff] ?? 0;
}
export function popcountColumn(value) {
    const column = value & TEXT_COLUMN_MASK;
    return popcountByte(column) + popcountByte(column >>> 8);
}
export function countColumnBits(columns, start = 0, end = columns.length) {
    let count = 0;
    for (let x = Math.max(0, start); x < Math.min(columns.length, end); x++)
        count += popcountColumn(columns[x] ?? 0);
    return count;
}
export function countAnchorBits(columns, start = 0, end = columns.length) {
    return countColumnBits(columns, start, end);
}
export function firstInkX(anchorColumns, inkColumns) {
    const width = Math.min(anchorColumns.length, inkColumns.length);
    for (let x = 0; x < width; x++) {
        if (((anchorColumns[x] ?? 0) | (inkColumns[x] ?? 0)) !== 0)
            return x;
    }
    return undefined;
}
export function lastInkX(anchorColumns, inkColumns) {
    const width = Math.min(anchorColumns.length, inkColumns.length);
    for (let x = width - 1; x >= 0; x--) {
        if (((anchorColumns[x] ?? 0) | (inkColumns[x] ?? 0)) !== 0)
            return x;
    }
    return undefined;
}
//# sourceMappingURL=mask.js.map